import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { BACKFILL_RANGE_OPTIONS } from "./helpers";

export default function FetchPastDialog({
  open,
  mailbox,
  busy,
  onClose,
  onSubmit,
}) {
  const [range, setRange] = useState("1d");
  const [unread, setUnread] = useState(true);
  const [read, setRead] = useState(true);

  useEffect(() => {
    if (!open) return;
    setRange("1d");
    setUnread(true);
    setRead(true);
  }, [open]);

  const bothOff = !unread && !read;
  const subtitle = mailbox?.imap_username || mailbox?.name || "";

  const handleClose = () => {
    if (busy) return;
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={!!busy}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Fetch past emails
        {subtitle ? (
          <Typography variant="body2" color="text.secondary">
            {subtitle}
          </Typography>
        ) : null}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <FormControl size="small" sx={{ maxWidth: 280 }} disabled={!!busy}>
            <InputLabel>Range</InputLabel>
            <Select
              label="Range"
              value={range}
              onChange={(e) => setRange(e.target.value)}
            >
              {BACKFILL_RANGE_OPTIONS.map((opt) => (
                <MenuItem key={opt.value} value={opt.value}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormGroup row>
            <FormControlLabel
              disabled={!!busy}
              control={(
                <Checkbox
                  checked={unread}
                  onChange={(e) => setUnread(e.target.checked)}
                />
              )}
              label="Unread"
            />
            <FormControlLabel
              disabled={!!busy}
              control={(
                <Checkbox
                  checked={read}
                  onChange={(e) => setRead(e.target.checked)}
                />
              )}
              label="Read"
            />
          </FormGroup>
          {bothOff && (
            <Typography variant="caption" color="text.secondary">
              Select unread and/or read emails
            </Typography>
          )}
          <Typography variant="caption" color="text.secondary">
            Already-imported emails are skipped.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={!!busy}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!!busy || bothOff}
          onClick={() => onSubmit({ range, unread, read })}
          startIcon={busy ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {busy ? "Fetching…" : "Fetch"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
